'use strict';

var URL = require('../generic/url');

var NavTabs = {
  active: function (event) {
    event.preventDefault();

    var $this = $(this);
    var $activeTab = $this.closest('.tabs').find('.is-active');
    var tabId = $this.data('id');

    if ($this.hasClass('is-active')) return;

    $activeTab.removeClass('is-active');
    $('#tab-' + $activeTab.data('id')).addClass('is-hide');
    $('#tab-' + tabId).removeClass('is-hide');
    $this.addClass('is-active');

    var urlSearch = URL.search(window.location.search);
    urlSearch.tab = tabId;

    var newUrl = window.location.pathname + '?' + decodeURIComponent($.param(urlSearch));
    history.pushState({}, null, newUrl);
  }
};

$('body').on('click tap', '.tabs .tab-item', NavTabs.active);
